import React, { type ComponentType } from 'react'

import { Carousel } from '../blocks/Carousel'
import { FAQs } from '../blocks/FAQs'
import { Hero } from '../blocks/Hero'
import { ImageTextColumns } from '../blocks/ImageTextColumns'
import { ImageWithText } from '../blocks/ImageWithText'
import { StepsWithImage } from '../blocks/StepsWithImage'
import { Table } from '../blocks/Table'
import { Testimonials } from '../blocks/Testimonials'
import type { CmsCtaIntentHandlers } from '../cta'
import { SafeBlock } from './SafeBlock'
import type { CmsPageFields, CmsPageSection } from './types'

// Block content-type uid → React component.
// Unknown block types are silently skipped at render time.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BLOCK_REGISTRY: Record<string, ComponentType<any>> = {
  carousel: Carousel,
  faqs: FAQs,
  hero: Hero,
  image_text_columns: ImageTextColumns,
  image_with_text: ImageWithText,
  steps_with_image: StepsWithImage,
  table: Table,
  testimonials: Testimonials,
}

type Props = {
  page: CmsPageFields
  ctaIntentHandlers?: CmsCtaIntentHandlers
}

export function PageRenderer({ page, ctaIntentHandlers }: Props): JSX.Element | null {
  if (!page.sections || page.sections.length === 0) {
    return null
  }

  return (
    <>
      {page.sections.map((section: CmsPageSection, index) => {
        const blockUid = Object.keys(section)[0]
        if (!blockUid) return null

        const Component = BLOCK_REGISTRY[blockUid]
        if (!Component) return null

        const fields = (section as Record<string, unknown>)[blockUid]
        const key = `${blockUid}-${index}`

        return (
          <SafeBlock key={key} blockKey={key}>
            <Component
              {...(fields as Record<string, unknown>)}
              ctaIntentHandlers={ctaIntentHandlers}
            />
          </SafeBlock>
        )
      })}
    </>
  )
}
